import React from 'react';
import PropTypes from 'prop-types';

import DNDComponent from "core/gd-modules/dnd/dnd-component";
import ListHeaderSortButton from "../sort/sort-button";
import ListHeaderMore from "../more/list-header-more";
import VerticalResizeSeparator from "core/gd-components/vertical-resize-separator/vertical-resize-separator";

const debug = false
// const debug = "ListHeaderTile"

export default class ListHeaderTile extends DNDComponent {

    static propTypes = {
        module      : PropTypes.object,
        column      : PropTypes.object,
        group       : PropTypes.object,

        canRemove   : PropTypes.bool,
        canMoveLeft : PropTypes.bool,
        isFirst     : PropTypes.bool,
        isLast      : PropTypes.bool,
    }

    static defaultProps = _.assign({}, DNDComponent.defaultProps, {
        dragTriggerDelta: 5,
    });

    componentDidMount() {
        super.componentDidMount();

        gd.bus.subscribe("column:resizing", this, this.onColumnResizing);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        gd.bus.unsubscribe(this);
    }

    getDNDId = () => this.props.column.fieldId

    _getDragDirection = (mouseEvent) => {
        let res = null;
        if (!!this.prevClientX) res = mouseEvent.clientX > this.prevClientX ? 'right' : mouseEvent.clientX < this.prevClientX ? 'left' : null;
        this.prevClientX = mouseEvent.clientX;
        return res;
    }

    onClick = (e) => {
        if(gd.utils.Dom.findNodeByClassName(e.target, ['more-icon'])) return;

        this.toggleSort(e, this.props.column.fieldId);
    }

    onMouseDown(e, callback) {
        if(gd.utils.Dom.findNodeByClassName(e.target, ['column-resize-separator'])) return;

        // prevent dnd if change columns order is not allowed
        if (this.props.dndManager && !this.props.module.canChangeColumnsOrder) return;

        return super.onMouseDown(e, callback);
    }

    _updateDragPointer(value) {
        switch (value) {
            case 'left':    this.removeClass('dragged-over-right'); this.addClass('dragged-over-left');  break;
            case 'right':   this.removeClass('dragged-over-left');  this.addClass('dragged-over-right'); break;
        }
    }

    onDragStart() {
        this.props.module.setDragInProgress(true);

        return super.onDragStart();
    }

    onDraggedOver(draggedItem, mouseEvent) {
        super.onDraggedOver(draggedItem, mouseEvent);

        const rect = _.pick(this.componentEl.getBoundingClientRect(), ['left', 'right', 'top', 'bottom']);
        const over = gd.utils.Dom.checkMouseOverRectArea(mouseEvent, rect);
        const newDraggedOver = over.xLine === 0 ? 'left' : 'right';
        let dragDirection;
        switch (newDraggedOver) {
            case 'left':    dragDirection = 'right'; break;
            case 'right':   dragDirection = 'left'; break;
        }

        this.dragDirection = dragDirection;
        this._updateDragPointer(dragDirection);
    }

    onDraggingOver(draggedItem, mouseEvent) {
        // determine if drag direction changed
        const dragDirection = this._getDragDirection(mouseEvent);
        const dragDirectionChanged = dragDirection && this.dragDirection && this.dragDirection !== dragDirection;
        if (dragDirection) this.dragDirection = dragDirection;

        if (dragDirectionChanged) this._updateDragPointer(dragDirection);
    }

    onDraggedOut(draggedItem, isOnDrop) {
        super.onDraggedOut(draggedItem, isOnDrop);

        this.removeClass('dragged-over-left');
        this.removeClass('dragged-over-right');
    }

    onDragEnd(mouseEvent, dx, dy, dropResult) {
        this.props.module.setDragInProgress(false);

        super.onDragEnd(mouseEvent, dx, dy, dropResult);

        this.props.module.columns.move(this.props.column.fieldId, dropResult.fieldId, dropResult.dragDirection);
    }

    onDrop(draggedItem, dropResult) {
        return _.assign({}, super.onDrop(draggedItem, dropResult), {fieldId: this.props.column.fieldId, dragDirection: this.dragDirection});
    }

    onColumnResizing = (data) => {
        if (data.groupValue === this.props.group?.groupByValue &&
            data.fieldId    === this.props.column.fieldId) {
            this.toggleClass('is-resizing', data.isResizing);
        } else {
            this.toggleClass('resize-in-progress', data.isResizing);
        }
    }

    toggleSort = (e, fieldId) => {
        e.stopPropagation();

        if (!this.props.module.canSort) return;

        this.props.module.sortBy.toggleSort(fieldId);
    }

    render() {
        const isTitle   = this.props.module.config.titleField === this.props.column.fieldId
        const isSticky  = isTitle && this.props.module.titleSticky

        const classes = Classes("cell", this.props.column.alignment, this.props.className, this.props.column.className, {
            'can-resize'    : this.props.module.config.canResizeColumns,
            'sticky'        : isSticky,
            'with-group-by' : !!this.props.module.groupBy,
            'is-first'      : this.props.isFirst,
            'is-last'       : this.props.isLast
        });

        // const field = this.props.module.fields.get(this.props.column.fieldId);

        const styles = {
            width:this.props.column.width
        }
        if (isSticky) {
            styles.left = this.props.module.skin.paddingLeft
        }

        return (
            <div className={classes} style={styles}>
                {!this.props.isFirst && this.props.module.config.canResizeColumns &&
                    <VerticalResizeSeparator
                        className   = "column-resize-separator left"
                        eventPrefix = {'column:{0}'.f(this.props.module.listId)}
                        data        = {{groupValue: this.props.group?.groupByValue, fieldId: this.props.column.fieldId, border: 'left'}}
                        type        = "both"
                        minLeft     = {-1000}
                        minRight    = {-1000}
                    />
                }

                <div className="drop-position i5-triangle-down"/>

                {!!this.props.dndManager &&
                    <div className="dnd-handle">
                        <div className="dnd-icon ui5-ico-16 ui5-icon-dnd"/>
                    </div>}

                <div className={Classes("label", this.props.column.headerLabelClassName)}>{this.props.column.label}</div>

                {this.props.module.canSort &&
                    <ListHeaderSortButton module={this.props.module} fieldId={this.props.column.fieldId}/>}

                {this.props.module.headerMoreButton &&
                    <ListHeaderMore module      = {this.props.module}
                                    column      = {this.props.column}
                                    dragEnabled = {!!this.props.dndManager}
                                    canRemove   = {this.props.canRemove}
                                    canResize   = {this.props.module.config.canResizeColumns}
                                    canMoveLeft = {this.props.canMoveLeft}
                                    isFirst     = {this.props.isFirst}
                                    isLast      = {this.props.isLast}/>}

                {this.props.module.config.canResizeColumns &&
                    <VerticalResizeSeparator
                        className   = "column-resize-separator right"
                        eventPrefix = {'column:{0}'.f(this.props.module.listId)}
                        data        = {{groupValue: this.props.group?.groupByValue, fieldId: this.props.column.fieldId, border: 'right'}}
                        type        = "left"
                        min         = {2}
                        max         = {1000}
                    />
                }

                {isSticky && <div className="sticky-shadow-emitter"/>}
            </div>
        )
    }
}
